import React from 'react'
import { Link } from 'react-router-dom'

function DevelopersCard({photo, email, name, linkedin, instagram}) {
  const emailUrl = `mailto:${email}`;
  return (
    <div style={{backgroundColor: '#D4BBDD'}} className='w-[23vmax] rounded-[0.5vmax] h-[28vmax] text-black font-bold flex gap-[1vmax] flex-col justify-center items-center'>
        <img className='w-[60%] h-[48%] rounded-full' src={photo} />
        <div className='w-full flex justify-center gap-[2vmax] items-center'><Link to={linkedin}><img className='w-[2vmax]' src='https://cdn-icons-png.freepik.com/256/174/174857.png?semt=ais_hybrid' /></Link><Link to={instagram}><img className='w-[2vmax]' src='https://upload.wikimedia.org/wikipedia/commons/thumb/a/a5/Instagram_icon.png/2048px-Instagram_icon.png' /></Link><Link to={emailUrl}><img className='w-[2vmax] rounded-[0.5vmax]' src='https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTHPt--X9aakj9tPFvnSNtzzt-kvANOH5hYww&s' /></Link></div>
        <div className='text-[1.5vmax]'>{name}</div>
    </div>
  )
}

export default DevelopersCard